import styled from 'styled-components';

import { Flex } from '@/components/Flex';

const HeaderUtils = styled(Flex)`
  flex-grow: 1;
  justify-content: end;
`;

export default HeaderUtils;
